// removed by extract-text-webpack-plugin
module.exports = {"container":"container_BeauPic","first":"first_BeauPic","title-wrapper":"title-wrapper_BeauPic","titleWrapper":"title-wrapper_BeauPic","feed-title":"feed-title_BeauPic","feedTitle":"feed-title_BeauPic","right":"right_BeauPic","item":"item_BeauPic"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeTop/BeauPic/BeauPic.scss
// module id = 277
// module chunks = 0